export default {
	listOfDeals:          [],
	filterValue:          'all',
	listOfPublicDeals:    [],
	listOfSuccessStories: [],
	search:               {
		str:          '',
		major_market: null,
		search:       null,
		order:        null,
	},

	page:                1,
	pages:               0,
	videoGuides:       [],
	videoGuidesErrors: [],
	subscriptionList:  [],
};
